export class Offset {
  pageSize: number;
  pageIndex: number;
  actualQuantityFilter: number;

  constructor(pageSize: number, pageIndex: number) {
    this.pageSize = pageSize;
    this.pageIndex = pageIndex;
  }
}
